<template>
  <button
    class="btn"
    style=" width: 90px;height: 90px"
    data-bs-toggle="tooltip"
  >
    <!-- <img
      style="max-width: 100%;height: auto;"
      :src="require(`@/assets/diablo2/images/item/${itemCategory.name}.png`)"
    />
    <br /> -->
    {{ itemCategory.nameKo }}
  </button>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: { itemCategoryName: String },
  data() {
    return { itemCategory: {} };
  },

  computed: {
    ...mapGetters("diablo2/itemCategory", ["getItemCategoryByName"]),
  },
  created: function() {
    this.itemCategory = this.getItemCategoryByName(this.itemCategoryName);
  },
  methods: {},
};
</script>

<style></style>
